import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, FileText, CheckCircle2, Clock } from "lucide-react";
import api from "@/lib/api";

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <div className="text-slate-400">Yükleniyor...</div>;

  const cards = [
    { label: "Toplam Ürün", v: s.urun_toplam, icon: Package, c: "bg-slate-900" },
    { label: "Yayında (Aktif)", v: s.urun_aktif, icon: CheckCircle2, c: "bg-emerald-600" },
    { label: "Taslak", v: s.urun_taslak, icon: Clock, c: "bg-amber-500" },
    { label: "Yeni Talep", v: s.teklif_yeni, icon: FileText, c: "bg-blue-600" },
    { label: "Fiyatlandırılıyor", v: s.teklif_fiyatlandiriliyor, icon: Clock, c: "bg-amber-600" },
    { label: "Gönderilen Teklif", v: s.teklif_gonderildi, icon: CheckCircle2, c: "bg-teal-600" },
  ];

  return (
    <div>
      <h1 className="font-head text-2xl font-bold text-slate-900 mb-6">Yönetim Paneli</h1>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {cards.map((c) => (
          <div key={c.label} className="bg-white border border-slate-200 rounded-xl p-5">
            <div className={`w-10 h-10 rounded-lg ${c.c} text-white flex items-center justify-center mb-3`}>
              <c.icon className="w-5 h-5" />
            </div>
            <div className="font-head text-3xl font-bold text-slate-900">{c.v}</div>
            <div className="text-sm text-slate-500 mt-1">{c.label}</div>
          </div>
        ))}
      </div>
      <div className="mt-8 flex gap-3">
        <Link to="/yonetim/teklifler" className="px-5 py-3 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700">
          Teklif Taleplerini Yönet</Link>
        <Link to="/yonetim/urunler" className="px-5 py-3 bg-white border rounded-lg text-sm font-medium hover:border-slate-300">
          Ürünleri Yönet</Link>
      </div>
    </div>
  );
}
